import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { request, gql, Variables } from 'graphql-request';

import { QueryKeys } from 'src/constants/queryKeys';

import { config } from '@app/config';
import { Pair } from '@app/types/pool';

export const fetcher = (baseUrl: string, params: Variables) => {
  return request<{ pair: Pair }>(
    `${baseUrl}`,
    gql`
      query {
        pair(
          id: "${params.id}"
        )
         {
          id
          token0 {
            id
            totalSupply
            symbol
            name
            decimals
            tradeVolumeUSD
            tradeVolume
            totalLiquidity
            txCount
            derivedETH
          }
          token1 {
            id
            totalSupply
            symbol
            name
            decimals
            tradeVolumeUSD
            tradeVolume
            totalLiquidity
            txCount
            derivedETH
          }
          isStable
          reserve0
          reserve1
          reserveETH
          reserveUSD
          token0Price
          token1Price
          volumeUSD
          totalSupply
          liquidityPositions {
            liquidityTokenBalance
            user {
              id
            }
          }
        }
      }
    `,
    params
  );
};

export const usePairDetails = (
  params: Variables = {},
  options: UseQueryOptions<Pair> = {}
) => {
  return useQuery<Pair>(
    [QueryKeys.PAIR_DETAILS, { params }],
    async () => {
      const response = await fetcher(config.subgraphUrl as string, {
        ...params
      });

      return response.pair;
    },
    {
      enabled: !!params.id,
      staleTime: 60000,
      ...options
    }
  );
};
